import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import Header from '../../components/Header'
import DashboardGrafical from '../../components/DashboardGrafical'
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'
import MobileMenu from '../../components/MobileMenu'
import { ToastContainer, toast } from 'react-toastify';
import TableListClients from '../../components/TableListClients'
import { ClientsContext } from '../../context/clients'

const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

   
  
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const RowDashboard = styled.div`

    display: flex;
    justify-content:space-between; 
    align-items: center;

    @media screen and (max-width:720px){
        width: 100%;
        flex-direction: column;
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const Clients = () => {
    const {count} = useContext(ClientsContext)
    const [structure] = useState([
        {
            name: "Id",
        },
        {
            name: "Cliente",
        },
        {
            name: "CPF"
        },
        {
            name: "Telefone"
        },
        {
            name: "Data"
        },
    ])
  

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar/>

                <div className='colum_secondary'>
                    <Header name="Meus Clientes "  />
                    <RowDashboard>
                        <DashboardGrafical name={"N Clientes"} value={count}  width={"27%"} marginTop={"0px"}/>
                    </RowDashboard>
                    <TableListClients structure={structure} />
                </div>

                

                <MobileMenu />

            </CardWrapper>
        </motion.div>

    )
}

export default Clients